<template>
    <div>
        <!-- 面包屑 -->
        <breadcrumbs></breadcrumbs>

        <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/valueAddedService/valueAddedService')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

        <!-- 查询条件 -->
        <div class="pdt-15 bg-white">
            <el-form ref="searchForm" :model="searchForm" label-width="100px" inline class="demo-form-inline"
                size='small'>
                <el-form-item label="产品名称" prop="productName">
                    <el-input v-model="searchForm.productName" clearable placeholder="请输入产品名称"></el-input>
                </el-form-item>

                <el-form-item label="产品有效期" prop="validityPeriod">
                    <el-select v-model="searchForm.validityPeriod" clearable placeholder="请选择有效期">
                        <el-option label="3天" value="3天"></el-option>
                        <el-option label="7天" value="7天"></el-option>
                        <el-option label="15天" value="15天"></el-option>
                        <el-option label="1年" value="1年"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="购买时间" prop="startTime">
                <el-date-picker
                    v-model="searchForm.startTime"
                    type="datetime"
                    placeholder="选择开始时间"
                    :picker-options="startTimeOptions"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    style="width: 200px;">
                </el-date-picker>
                至
                <el-date-picker
                    v-model="searchForm.endTime"
                    type="datetime"
                    placeholder="选择结束时间"
                    :picker-options="endTimeOptions"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    style="width: 200px;">
                </el-date-picker>
            </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleSearch">查询</el-button>
                    <el-button @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div>
            <el-button type="primary" @click="handleExport">导出</el-button>
        </div>

        <!-- 表格 -->
        <div class="mgt-15 bg-white">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column type="index" label="序号"  align="center" width="70"></el-table-column>
                <el-table-column prop="productName" label="产品名称" align="center"></el-table-column>
                <el-table-column prop="validityPeriod" label="产品有效期" align="center"></el-table-column>
                <el-table-column prop="purchaserName" label="购买人员" align="center"></el-table-column>
                <el-table-column prop="purchaserPhone" label="人员电话"  align="center"></el-table-column>
                <el-table-column prop="price" label="实付价格（元）" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.price ? scope.row.price.toFixed(2) : '0.00' }}
                    </template>
                </el-table-column>
                <el-table-column prop="paymentVoucher" label="付款凭证"  align="center">
                    <template slot-scope="scope">
                        <el-button 
                            type="text" 
                            size="mini" 
                            @click="viewPaymentVoucher(scope.row)">
                            查看
                        </el-button>
                    </template>
                </el-table-column>

                <!-- <el-table-column prop="paymentVoucher" label="付款凭证"  align="center">
                    <template slot-scope="scope">
                        <el-button 
                            v-if="scope.row.paymentVoucher" 
                            type="text" 
                            size="mini" 
                            @click="viewPaymentVoucher(scope.row.orderNo, scope.row.needInvoice)">
                            查看
                        </el-button>
                        <span v-else>无</span>
                    </template>
                </el-table-column> -->

                
                <el-table-column label="购买时间" align="center">
                    <template slot-scope="scope">
                        <!-- {{ formatDate(scope.row.createdAt) }} -->
                          {{scope.row.createdAt }}
                    </template>
                </el-table-column>
                <el-table-column label="到期时间" align="center">
                    <template slot-scope="scope">
                        {{ formatDate(scope.row.expireTime) }}
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination
                class="mgt-15 mgb-15"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <!-- 发票信息弹窗 -->
        <el-dialog title="发票信息" :visible.sync="invoiceDialogVisible" width="500px">
            <el-form :model="invoiceForm" label-width="100px">
                <el-form-item label="发票抬头">
                    <span>{{ invoiceForm.invoiceTitle || '--' }}</span>
                </el-form-item>
                <el-form-item label="税号">
                    <span>{{ invoiceForm.taxNumber || '--' }}</span>
                </el-form-item>
                <el-form-item label="邮箱地址">
                    <span>{{ invoiceForm.email || '--' }}</span>
                </el-form-item>
                <el-form-item label="发票类型">
                    <span>{{ getInvoiceTypeText(invoiceForm.invoiceType) }}</span>
                </el-form-item>
                <el-form-item label="备注">
                    <span>{{ invoiceForm.remark || '--' }}</span>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="invoiceDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 导出商品弹窗 -->
        <el-dialog title="导出商品" :visible.sync="exportGoodsVisible" width="600px">
            <el-form ref="exportGoodsForm" :model="exportGoodsForm" label-width="100px">
                <el-form-item label="产品名称" prop="productName">
                    <el-input v-model="exportGoodsForm.productName" placeholder="请输入产品名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="是否开票" prop="needInvoice">
                    <el-select v-model="exportGoodsForm.needInvoice" placeholder="请选择是否开票" clearable>
                        <el-option label="是" :value="true"></el-option>
                        <el-option label="否" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品类型" prop="productType">
                    <el-select v-model="exportGoodsForm.productType" placeholder="请选择产品类型" clearable>
                        <el-option label="普通产品" :value="1"></el-option>
                        <el-option label="特价产品" :value="2"></el-option>
                        <el-option label="免费产品" :value="3"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="exportGoodsVisible = false">取消</el-button>
                <el-button type="primary" @click="submitExportGoods">导出</el-button>
            </div>
        </el-dialog>

        <!-- 支付凭证预览弹窗 -->
        <el-dialog title="支付凭证" :visible.sync="paymentVoucherVisible" width="600px">
            <div v-if="currentPaymentVoucher">
                <img :src="currentPaymentVoucher" style="max-width: 100%;" alt="支付凭证">
            </div>
            <div v-else>
                暂无支付凭证
            </div>
        </el-dialog>

    </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
    components: {
        breadcrumbs,
        btns,
    },
    data() {
        return {
            // 搜索表单
            searchForm: {
                productName: '',
                validityPeriod: '',
                purchaseDateRange: [],
                startTime: '',
                endTime: ''
            },
            
            // 表格数据
            tableData: [],
            
            // 分页
            pageNum: 1,
            pageSize: 10,
            total: 0,
            
            // 发票弹窗
            invoiceDialogVisible: false,
            invoiceForm: {
                invoiceTitle: '',
                taxNumber: '',
                email: '',
                invoiceType: '',
                remark: ''
            },
            exportGoodsVisible: false,
            exportGoodsForm: {
                productName: '',
                needInvoice: null,
                productType: null,
                invoiceType: null,
                type:1
            },
            paymentVoucherVisible: false,
        }
    },
     computed: {
        // 开始时间选择器选项
        startTimeOptions() {
            return {
                // 结束时间之后的时间不可选
                disabledDate: (time) => {
                    if (this.searchForm.endTime) {
                        const endTime = new Date(this.searchForm.endTime);
                        return time.getTime() > endTime.getTime();
                    }
                    return false;
                },
                // 选择开始时间时的回调
                onPick: (maxDate, minDate) => {
                    // 这里可以添加额外的逻辑
                }
            }
        },
        
        // 结束时间选择器选项
        endTimeOptions() {
            return {
                // 开始时间之前的时间不可选
                disabledDate: (time) => {
                    if (this.searchForm.startTime) {
                        const startTime = new Date(this.searchForm.startTime);
                        return time.getTime() < startTime.getTime();
                    }
                    return false;
                },
                // 选择结束时间时的回调
                onPick: (maxDate, minDate) => {
                    // 这里可以添加额外的逻辑
                }
            }
        }
    },
    watch: {
        // 监听开始时间变化
        'searchForm.startTime': function(newVal, oldVal) {
            if (newVal) {
                // 如果选择了开始时间，且结束时间在开始时间之前，则清空结束时间
                if (this.searchForm.endTime) {
                    const startTime = new Date(newVal);
                    const endTime = new Date(this.searchForm.endTime);
                    if (endTime < startTime) {
                        this.searchForm.endTime = '';
                    }
                }
            }
        },
        
        // 监听结束时间变化
        'searchForm.endTime': function(newVal, oldVal) {
            if (newVal) {
                // 如果选择了结束时间，且开始时间在结束时间之后，则清空开始时间
                if (this.searchForm.startTime) {
                    const startTime = new Date(this.searchForm.startTime);
                    const endTime = new Date(newVal);
                    if (startTime > endTime) {
                        this.searchForm.startTime = '';
                    }
                }
            }
        }
    },
    mounted() {
        this.getOrderList();
    },
    methods: {
        // 查询订单列表
        async getOrderList() {
            try {
                const params = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    productName: this.searchForm.productName,
                    validityPeriod: this.searchForm.validityPeriod,
                    startTime: this.searchForm.startTime,
                    endTime: this.searchForm.endTime,
                };

                
                
                
                const res = await this.$api.valueAddedService.getOrderList(params);
                console.log('获取订单列表', res);
                
                if (res.code === 200) {
                    this.tableData = res.data.rows || [];
                    this.total = res.data.total || 0;
                } else {
                    handleAlert(res.msg || '获取订单列表失败', 'error');
                    this.tableData = [];
                    this.total = 0;
                }
            } catch (error) {
                console.error('获取订单列表失败:', error);
                handleAlert('获取订单列表失败', 'error');
                this.tableData = [];
                this.total = 0;
            }
        },
        
        // 查询按钮
        handleSearch() {
            this.pageNum = 1;
            this.getOrderList();
        },
        viewPaymentVoucher(row) {
            this.currentPaymentVoucher = row.paymentVoucher;
            this.paymentVoucherVisible = true;
        },
        
        // 重置按钮
        handleReset() {
            this.$refs.searchForm.resetFields();
            this.searchForm.purchaseDateRange = [];
            this.searchForm.startTime = '';
            this.searchForm.endTime = '';
            this.pageNum = 1;
            this.getOrderList();
        },
        
        // 查看付款凭证
        async handleViewVoucher(orderNo,needInvoice) {
            if(!needInvoice){
                handleAlert('该订单没有上传发票，无法查看付款凭证', 'info');
                return;
            }
            try {
                const res = await this.$api.valueAddedService.getPaidGoodsVoucher({ orderNo });
                console.log('获取付款凭证', res);
                
                if (res.code === 200) {
                    // 假设返回的数据结构为 res.data
                    this.invoiceForm = {
                        invoiceTitle: res.data.invoiceTitle || '',
                        taxNumber: res.data.taxNumber || '',
                        email: res.data.email || '',
                        invoiceType: res.data.invoiceType || '',
                        remark: res.data.remark || ''
                    };
                    this.invoiceDialogVisible = true;
                } else {
                    handleAlert(res.msg || '获取发票信息失败', 'error');
                }
            } catch (error) {
                console.error('获取付款凭证失败:', error);
                handleAlert('获取发票信息失败', 'error');
            }
        },
        
        // 格式化日期
        formatDate(dateString) {
            if (!dateString) return '--';
            try {
                const date = new Date(dateString);
                return date.toLocaleDateString('zh-CN');
            } catch (error) {
                return dateString;
            }
        },
        
        // 发票类型转换
        getInvoiceTypeText(type) {
            const typeMap = {
                '1': '普通发票',
                '2': '增值税发票',
                '3': '电子发票'
            };
            return typeMap[type] || type || '--';
        },
        
        // 分页大小变化
        handleSizeChange(val) {
            this.pageSize = val;
            this.getOrderList();
        },
        
        // 当前页变化
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getOrderList();
        },
        handleExport(){
            // 每次打开导出商品弹窗，清空导出数据
            this.exportGoodsForm={
                productName:'',
                needInvoice:null,
                productType:null,
                invoiceType:null,
                type:1
            }
            this.exportGoodsVisible = true;
            // this.$api.valueAddedService.exportGoods({
            //     pageNum: this.pageNum,
            //     pageSize: this.pageSize,
            //     productName: this.searchForm.productName,
            //     validityPeriod: this.searchForm.validityPeriod
            // }).then(res => {
            //     if (res.code === 200) {
            //         // 处理导出成功逻辑
            //         handleAlert('导出成功', 'success');
            //     } else {
            //         handleAlert(res.msg || '导出失败', 'error');
            //     }
            // }).catch(error => {
            //     console.error('导出失败:', error);
            //     handleAlert('导出失败', 'error');
            // });
        },
        // 导出商品
        submitExportGoods(){
            this.$refs.exportGoodsForm.validate(valid => {
                if (valid) {
                    this.$api.valueAddedService.exportGoods(this.exportGoodsForm).then(res => {
                        console.log('导出商品', res);
                            // 处理导出成功逻辑
                            handleAlert('导出成功', 'success');
                            // 下载文件
                            const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
                            const link = document.createElement('a');
                            link.href = URL.createObjectURL(blob);
                            link.download = '导出商品.xlsx';
                            link.click();
                            URL.revokeObjectURL(link.href);
                        this.exportGoodsVisible = false;
                    }).catch(error => {
                        console.error('导出失败:', error);
                        handleAlert('导出失败', 'error');
                    });
                } else {
                    handleAlert('请填写完整导出商品信息', 'warning');
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.pdt-15 {
    padding-top: 15px;
}

.mgt-15 {
    margin-top: 15px;
}

.mgb-15 {
    margin-bottom: 15px;
}

.bg-white {
    background: var(--card-bg);
    padding: 15px;
    border-radius: 4px;
}

// 表格样式
.el-table {
    font-size: 14px;
    
    ::v-deep .cell {
        padding: 8px 0;
    }
}

// 分页样式
.el-pagination {
    text-align: right;
}

// 弹窗样式
.el-form-item {
    margin-bottom: 15px;
    
    span {
        display: inline-block;
        padding: 8px 12px;
        background: var(--card-bg);
        border-radius: 4px;
        min-width: 200px;
    }
}

// 搜索表单样式
.demo-form-inline {
    .el-form-item {
        margin-bottom: 15px;
    }
}
</style>